import axios from '../../../../../api/axios';

export const initialState = {
  order: null,
  bidders: null,
  biddersPage: 1,
  driversPage: 1,
  drivers: null,
  params: null,
  driverInterests: true,
  justProperFleets: false,
  search: {},
};
export const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'ORDER':
      return { ...state, order: payload };
    case 'BIDDERS':
      return { ...state, bidders: payload };
    case 'DRIVERS':
      return { ...state, drivers: payload };
    case 'PARAMS':
      return { ...state, params: payload };
    case 'COMMISSIONS':
      return { ...state, params: payload };
    case 'CHANGE_BIDDERS_PAGE':
      return { ...state, biddersPage: payload };
    case 'CHANGE_DRIVERS_PAGE':
      return { ...state, driversPage: payload };
    case 'CHANGE_WAYBILL_TYPE':
      return { ...state, order: { ...state.order, waybillType: payload } };
    case 'CHANGE_CUSTOM_COMMISSION':
      return { ...state, order: { ...state.order, customCommission: payload } };
    case 'CHANGE_SEARCH':
      return {
        ...state,
        search: { ...state.search, [payload.name]: payload.value },
      };
    case 'CHANGE_DRIVER_INTERESTS':
      return { ...state, driverInterests: payload };
    case 'CHANGE_PROPER_FLEET':
      return { ...state, justProperFleets: payload };
    case 'DRIVERS_MARKETING_LOG': {
      const { driverId, marketingLog } = payload;
      const driverIndex = state.drivers.docs.findIndex(
        (item) => item._id === driverId
      );
      state.drivers.docs[driverIndex].marketingLog = marketingLog;
      return state;
    }
    default:
      return state;
  }
};
export const actions = {
  fetchingOrder: async (id) => {
    try {
      const { data } = await axios.get(`/api/v1/admin/order/${id}`);
      return data;
    } catch (error) {
      return new Error(error);
    }
  },
  calculatingCommissions: async (orderId) => {
    try {
      const { data } = await axios.get(
        `/api/v1/admin/orders/tendering/${orderId}/fullCommissionDetails`
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  fetchingDrivers: async (id, signal) => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      // urlSearchParams.set('driverInterests', driverInterests);
      // urlSearchParams.set('justProperFleets', justProperFleets);
      // page && urlSearchParams.set('page', page);
      // limit && urlSearchParams.set('limit', limit);
      const {
        data: drivers,
      } = await axios.get(
        `/api/v1/admin/orders/tendering/${id}/drivers?${urlParams.toString()}`,
        { signal }
      );
      return drivers;
    } catch (error) {
      return new Error(error);
    }
  },
  fetchingBidders: async (id, page, limit, signal) => {
    try {
      const {
        data: drivers,
      } = await axios.get(
        `/api/v1/admin/orders/tendering/${id}/list/bidders/${page}/${limit}`,
        { signal }
      );
      return drivers;
    } catch (error) {
      return new Error(error);
    }
  },
  changeStatus: async (orderId, status) => {
    try {
      const { data } = await axios.post(`/api/v1/admin/orders/changeStatus`, {
        orderId,
        status,
      });
      return data;
    } catch (error) {
      throw error;
    }
  },
  fetchingOrderParams: async (orderId) => {
    try {
      const { data } = await axios.get(
        `/api/v1/admin/orders/getParams/${orderId}`
      );
      return data;
    } catch (error) {
      return new Error(error);
    }
  },
};
